import type { PharmacyQueueState } from './types';

export const initialState: PharmacyQueueState = {
  selectedInstitution: null,
  selectedPharmacy: null,
  queueNumber: null,
};
